!(function () {
  // Target the main product button, not the sticky one
  const e = document.querySelector(".button--add-to-cart--primary"),
    t = document.querySelector(".sticky-add-to-cart"),
    o = document.querySelectorAll(".scroll-atc");
  
  // Debug: Log initial element states
  console.log("🔍 Sticky Cart Debug - Initial Setup:");
  console.log("  Add to cart button found:", !!e, e);
  console.log("  Sticky element found:", !!t, t);
  console.log("  Scroll ATC elements found:", o.length);
  console.log("  Shopify design mode:", Shopify.designMode);
  
  // Debug: Log sticky element prepend
  if (t) {
    console.log("  Prepending sticky element to body");
    document.body.prepend(t);
  } else {
    console.warn("⚠️  Sticky element not found - cannot prepend to body");
  }
  
  // Set up intersection observer with comprehensive debugging
  if (e && !Shopify.designMode) {
    console.log("🎯 Setting up intersection observer");
    console.log("  Target element:", e);
    console.log("  Target element classes:", e.className);
    console.log("  Target element ID:", e.id);
    console.log("  Target element tagName:", e.tagName);
    
    // Get initial button position for reference
    const initialRect = e.getBoundingClientRect();
    console.log("  Initial button position:");
    console.log("    top:", initialRect.top.toFixed(2));
    console.log("    bottom:", initialRect.bottom.toFixed(2));
    console.log("    height:", initialRect.height.toFixed(2));
    console.log("    scroll Y:", window.scrollY);
    
    let callbackCount = 0;
    let lastState = null;
    
    new window.IntersectionObserver(
      (entries) => {
        let [entry] = entries;
        callbackCount++;
        
        // Get current viewport info for context
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;
        
        // REALITY CHECK: Get the button's actual current position
        const actualRect = e.getBoundingClientRect();
        
        console.log(`📊 Intersection Observer Callback #${callbackCount}:`);
        console.log("  === OBSERVER ENTRY DATA ===");
        console.log("  isIntersecting:", entry.isIntersecting);
        console.log("  intersectionRatio:", entry.intersectionRatio.toFixed(3));
        console.log("  boundingClientRect.top:", entry.boundingClientRect.top.toFixed(2));
        console.log("  boundingClientRect.bottom:", entry.boundingClientRect.bottom.toFixed(2));
        console.log("  boundingClientRect.height:", entry.boundingClientRect.height.toFixed(2));
        
        console.log("  === REALITY CHECK (getBoundingClientRect) ===");
        console.log("  ACTUAL button top:", actualRect.top.toFixed(2));
        console.log("  ACTUAL button bottom:", actualRect.bottom.toFixed(2));
        console.log("  ACTUAL button height:", actualRect.height.toFixed(2));
        console.log("  ACTUAL button width:", actualRect.width.toFixed(2));
        console.log("  Do positions match?", Math.abs(entry.boundingClientRect.top - actualRect.top) < 1);
        
        console.log("  === VIEWPORT CONTEXT ===");
        console.log("  viewport height:", viewportHeight);
        console.log("  scroll Y:", scrollY);
        console.log("  button visible area (top to bottom):", `${actualRect.top.toFixed(2)} to ${actualRect.bottom.toFixed(2)}`);
        console.log("  button is CLEARLY visible?", actualRect.top > 0 && actualRect.bottom < viewportHeight);
        console.log("  button is PARTIALLY above viewport?", actualRect.top < 0 && actualRect.bottom > 0);
        console.log("  button is COMPLETELY above viewport?", actualRect.bottom < 0);
        console.log("  button is COMPLETELY below viewport?", actualRect.top > viewportHeight);
        
        console.log("  === CONDITION EVALUATION ===");
        const isIntersecting = entry.isIntersecting;
        const topGreaterThanZero = entry.boundingClientRect.top > 0;
        const hideCondition = isIntersecting || topGreaterThanZero;
        
        console.log("  isIntersecting:", isIntersecting);
        console.log("  boundingClientRect.top > 0:", topGreaterThanZero);
        console.log("  HIDE condition (isIntersecting || top > 0):", hideCondition);
        console.log("  SHOW condition (opposite):", !hideCondition);
        
        // Expected behavior check
        console.log("  === EXPECTED vs ACTUAL ===");
        const shouldBeVisible = actualRect.top > 0; // Button clearly in view
        const shouldShowSticky = actualRect.bottom < 0; // Button scrolled past
        console.log("  Button clearly visible (top > 0):", shouldBeVisible);
        console.log("  Should show sticky (button scrolled past):", shouldShowSticky);
        console.log("  Current logic will show sticky:", !hideCondition);
        console.log("  Logic matches expected behavior?", !hideCondition === shouldShowSticky);
        
        const currentState = hideCondition ? 'hidden' : 'visible';
        console.log("  calculated state:", currentState);
        console.log("  last state:", lastState);
        
        // Apply the logic
        if (hideCondition) {
          console.log("🫥 HIDING sticky element (removing 'active' class)");
          t?.classList.remove("active");
        } else {
          console.log("👁️  SHOWING sticky element (adding 'active' class)");
          t?.classList.add("active");
        }
        
        // Check if state actually changed
        if (currentState !== lastState) {
          console.log("  ✅ STATE CHANGED:", lastState, "→", currentState);
        } else {
          console.log("  ⚠️  NO STATE CHANGE but callback fired anyway");
        }
        
        lastState = currentState;
        console.log("---");
      },
      { root: null, threshold: 1 }
    ).observe(e);
  } else {
    console.log("❌ Intersection observer NOT set up:");
    console.log("  Button exists:", !!e);
    console.log("  Not in design mode:", !Shopify.designMode);
  }
  
  // Set up scroll-to-cart button listeners with debugging
  if (o && o.length > 0) {
    console.log("🔗 Setting up scroll ATC listeners for", o.length, "elements");
    o.forEach((scrollElement, index) => {
      scrollElement.addEventListener("click", function (clickEvent) {
        console.log(`🖱️  Scroll ATC #${index} clicked`);
        
        let navOffset,
          targetOffset,
          c = document.querySelector(".product-converter"),
          r = document.querySelector(".product-converter__add-to-cart"),
          n = document.getElementById("nav-wrapper");
        
        navOffset = n ? n.offsetHeight + 100 : 150;
        targetOffset = r ? r.offsetTop : c.offsetTop;
        
        let scrollTarget = targetOffset - navOffset;
        console.log("🚀 Scrolling to:", scrollTarget);
        window.scrollTo({ top: scrollTarget, behavior: "smooth" });
      });
    });
  } else {
    console.log("❌ No scroll ATC elements found");
  }
})();
